export default __webpack_public_path__ + "static/tokenomics@2x-cc9fdcd7ba0c14f7e2d4db6408487c39.png";